const mapper_options = {
  endpoint: 'retailer_share_summaries',
  recordClass: require('./record')
}

module.exports = (store) => {
  store.defineMapper('campaign_reporting_retailer_share_summary', mapper_options)
}
